import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Header() {
  const { user, logout } = useAuth();

  return (
    <header className="site-header" role="banner">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <Link to="/" className="flex items-center space-x-3 group" aria-label="Rohimaya Health AI - Home">
            <img
              src="/rohimaya-logo-circle.png"
              alt="Rohimaya Health AI logo"
              className="h-10 w-10 rounded-lg shadow-md group-hover:scale-110 transition-transform"
            />
            <div className="hidden sm:block">
              <h1 className="text-xl font-bold">Rohimaya Health AI</h1>
              <p className="text-xs opacity-80">Intelligent Healthcare Management</p>
            </div>
          </Link>

          <nav className="flex space-x-1 sm:space-x-2 ml-4 sm:ml-8" aria-label="Main navigation">
            <Link
              to="/"
              className="px-3 sm:px-4 py-2 rounded-lg hover:bg-white/10 transition-all font-medium text-sm sm:text-base min-h-touch flex items-center"
              aria-label="Priority Patients"
            >
              <svg className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              <span className="hidden sm:inline">Priority</span>
              <span className="sr-only sm:hidden">Priority Patients</span>
            </Link>
            <Link
              to="/alerts"
              className="px-3 sm:px-4 py-2 rounded-lg hover:bg-white/10 transition-all font-medium text-sm sm:text-base min-h-touch flex items-center"
              aria-label="Patient Alerts"
            >
              <svg className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
              <span className="hidden sm:inline">Alerts</span>
              <span className="sr-only sm:hidden">Patient Alerts</span>
            </Link>
          </nav>
        </div>

        <div className="flex items-center space-x-3 sm:space-x-4">
          <div className="hidden md:flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg" aria-label="User profile">
            <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center text-sm font-bold" aria-hidden="true">
              {user?.name?.split(' ').map(n => n[0]).join('').toUpperCase() || 'U'}
            </div>
            <div className="text-sm">
              <p className="font-semibold">{user?.name}</p>
              <p className="text-xs text-white/70">{user?.role}</p>
            </div>
          </div>
          <button
            onClick={logout}
            className="px-4 py-2 rounded-lg bg-white/10 hover:bg-white/20 transition-all font-medium text-sm border border-white/20 hover:border-white/30 min-h-touch flex items-center gap-2"
            aria-label="Logout from application"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            <span className="hidden sm:inline">Logout</span>
          </button>
        </div>
      </div>
    </header>
  );
}
